/* @flow */
import styled from "styled-components";

export default styled.div`
  position: relative;
  height: 53px;
  background-color: ${props => props.theme.main};

  @media (max-width: 959px) {
    height: 38px;
  }

  @media (min-width: 960px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 174px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Toolbar/Bar.js